import React from "react";
import { TabViewChooser, TabViewChooserProps } from "../TabViewChooser/TabViewChooser";
import { SprayChartGenerator } from "./SprayChartGenerator";
import Styles from "./SprayChart.module.scss";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";
import { Text } from "src/components/atoms/Text/Text";
import { useParams } from "react-router-dom";
import * as Team from "src/state/modules/team/types";
import * as Eden from "src/eden/content";
import { useGetTeamSprayChartByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";

export const SprayChart = () => {
  const { id, pid } = useParams();
  const sprayChartTabs = ["Batting", "Pitching"];
  const [currentTab, setCurrentTab] = React.useState(sprayChartTabs[0]);
  const tabSelectorClickHandler = (tabName: string) => {
    for (const availableTab of sprayChartTabs) {
      if (availableTab.toLowerCase() === tabName.toLowerCase()) {
        setCurrentTab(availableTab);
      }
    }
  };

  const { data, error: sprayError, isLoading: sprayIsLoading } = useGetTeamSprayChartByIDQuery(id ?? "");

  const tabProps: TabViewChooserProps = {
    options: sprayChartTabs,
    onClick: tabSelectorClickHandler,
    active: currentTab,
  };

  if (data === undefined) return <PageLoader1 />;

  const getPlayerOffensiveSprayCharts = (): Eden.SprayChartData[] => {
    if (data !== undefined && pid !== undefined) {
      const filteredSprayData = data
        ?.map((value) => value.spray_chart_data?.offense)
        .filter((value) => value !== undefined && value.hasOwnProperty(pid))
        .map((value) => value[pid] || {});
      const flattenedResults = filteredSprayData.flatMap((value) => value);
      return flattenedResults as Eden.SprayChartData[];
    }
    return [] as Eden.SprayChartData[];
  };

  const getPlayerDefensiveSprayCharts = (): Eden.SprayChartData[] => {
    if (data !== undefined && pid !== undefined) {
      const filteredSprayData = data
        ?.map((value) => value.spray_chart_data?.defense)
        .filter((value) => value !== undefined && value.hasOwnProperty(pid))
        .map((value) => value[pid] || {});
      const flattenedResults = filteredSprayData.flatMap((value) => value);
      return flattenedResults as Eden.SprayChartData[];
    }
    return [] as Eden.SprayChartData[];
  };

  const hitData: Eden.SprayChartData[] = getPlayerOffensiveSprayCharts();
  const pitchData: Eden.SprayChartData[] = getPlayerDefensiveSprayCharts();
  const displayedData = currentTab === "Batting" ? hitData : pitchData;
  const noData = displayedData.length === 0;

  const noDataNotification = () => (
    <>
      <Text color={"coolGreyDark"} size={"large"} align={"center"} weight={"xbold"} className={Styles.noData}>
        No data for this season
      </Text>
      <SprayChartGenerator sprayChartData={[]} />
    </>
  );

  return (
    <>
      <OldRow>
        <TabViewChooser {...tabProps} />
      </OldRow>
      <figure className={Styles.container}>
        {noData ? noDataNotification() : <SprayChartGenerator sprayChartData={displayedData} />}
      </figure>
    </>
  );
};
function useSelector(getPlayerOffensiveSprayCharts: any): Team.SprayChartData[] {
  throw new Error("Function not implemented.");
}
